import { InvoiceType } from "./models/common-types";

export const mapInvoiceTypeToPrefix = (type: InvoiceType, year: number) => {
  const dict = {
    invoice: `INV-${year}`,
    proforma: `PRM-${year}`,
    estimate: `EST-${year}`,
    purchase_order: `PO-${year}`,
  };

  return dict[type];
};
